import { AnimationEvent, ReactElement, useEffect, useState } from 'react';
import classNames from 'classnames';

import styles from './styles.module.sass';

type AnimateProps = {
  children: ReactElement;
  isVisible: boolean;
  hasImmediateExit?: boolean;
};

const Animate = ({ children, isVisible, hasImmediateExit = false }: AnimateProps) => {
  const [isInDOM, setIsInDOM] = useState(isVisible);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsExiting(false);
      setIsInDOM(true);
      return;
    }
    setIsExiting(true);
  }, [isVisible, hasImmediateExit]);

  const handleAnimationEnd = (event: AnimationEvent<HTMLSpanElement>) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation();
      if (isExiting) {
        setIsInDOM(false);
        setIsExiting(false);
      }
    }
  };

  return isInDOM ? (
    <div
      className={classNames(
        styles.wrapper,
        { [styles.exiting!]: isExiting },
        { [styles.immediateExit!]: hasImmediateExit },
      )}
      onAnimationEnd={handleAnimationEnd}
    >
      {children}
    </div>
  ) : null;
};

export default Animate;
